import React from 'react';

/**
 * AdminHeader - Header component for AdminDashboard
 * 
 * @param {Object} props - Component props
 * @param {string} [props.title='Admin Workspace'] - Main title
 * @param {string} [props.subtitle=''] - Subtitle/description
 * @param {React.ReactNode} [props.actionButton] - Action button to display on the right
 * @param {string} [props.breadcrumb=''] - Breadcrumb text
 * @returns {React.ReactElement} Admin header component
 */
const AdminHeader = ({
  title = 'Admin Workspace',
  subtitle = '',
  actionButton = null,
  breadcrumb = ''
}) => {
  return (
    <>
      {/* Breadcrumb */}
      {breadcrumb && (
        <div style={{ 
          display: 'flex', 
          gap: '0.5rem', 
          alignItems: 'center', 
          fontSize: '0.85rem', 
          color: 'var(--text-secondary)' 
        }}>
          <span>Admin Panel</span>
          <i className="fa-solid fa-chevron-right" style={{ fontSize: '0.7rem' }}></i>
          <span style={{ color: 'var(--text-primary)', fontWeight: 500 }}>
            {breadcrumb}
          </span>
        </div>
      )}

      {/* Main Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 style={{ fontSize: '1.35rem', margin: 0, fontWeight: 700 }}>{title}</h1>
          {subtitle && (
            <p style={{ 
              color: 'var(--text-secondary)', 
              margin: '0.25rem 0 0 0', 
              fontSize: '0.95rem' 
            }}>
              {subtitle}
            </p>
          )}
        </div>
        {actionButton && (
          <div>
            {actionButton}
          </div>
        )}
      </div>
    </>
  );
};

export default AdminHeader;